/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IdleUserTimes } from '../../services/shared/shared-enums';


@Injectable({
	providedIn: 'root'
})
export class IdleUserService 
{
	public timeoutId: any;
	public countdownId: any;
	public countdownValue: number = 0;

	userInactive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor() 
	{
		this.reset();
		this.initListener();
	}

	initListener() 
	{
		window.addEventListener('mousemove', () => this.reset());
		window.addEventListener('click', () => this.reset());
		window.addEventListener('keypress', () => this.reset());
		window.addEventListener('DOMMouseScroll', () => this.reset());
		window.addEventListener('mousewheel', () => this.reset());
		window.addEventListener('touchmove', () => this.reset());
		window.addEventListener('MSPointerMove', () => this.reset());
	}

	reset() 
	{
		clearTimeout(this.timeoutId);
		clearTimeout(this.countdownId);
		this.startIdleTimer();
		this.userInactive.next(false);

	}

	startIdleTimer() 
	{
		this.timeoutId = setTimeout(() => 
		{
			this.startCountdown();
		}, IdleUserTimes.idleTime);
	}

	startCountdown() 
	{
		this.countdownValue = IdleUserTimes.countdownTime / 1000;
		this.countdownId = setInterval(() => 
		{
			this.countdownValue--;
			if (this.countdownValue <= 0) 
			{
				clearInterval(this.countdownId);
				this.userInactive.next(true);
			}
		}, 1000);
	}
}
